import { TeamAvatar } from '@sorare/core/src/components/club/TeamAvatar';
import { ASSETS_HOST } from '@sorare/core/src/constants/assets';
import { GqlFilterTitle } from '@sorare/core/src/contexts/graphql-search';
import { FILTERS, type FilterWidget } from '@sorare/core/src/lib/filters';

import {
  RefineBackendI18nList,
  buildRefineI18nList,
} from '#src/searchCards/RefineI18nList/index.tsx';

const getClubAvatarUrl = (slug: string) =>
  `${ASSETS_HOST}/team/picture/icons/${slug}.png`;

const sliceLongNameWithoutType = (option: string) => {
  const [name, slug, code] = option.split('|');
  return { name, slug, code };
};

const sliceLongNameWithSlug = (option: string) => {
  const [name, slug, type, code] = option.split('|');
  return { name, slug, type, code };
};

const renderBefore = (option: string) => {
  const { name, slug, type, code } = sliceLongNameWithSlug(option);

  if (type === 'Football::NationalTeam' && code) {
    return (
      <TeamAvatar
        size={24}
        team={{
          __typename: 'NationalTeam',
          slug,
          name,
          avatarUrl: null,
          country: { __typename: 'Country', slug: code, name },
        }}
      />
    );
  }

  return (
    <TeamAvatar
      size={24}
      team={{
        __typename: 'Club',
        slug,
        name,
        avatarUrl: getClubAvatarUrl(slug),
      }}
    />
  );
};

const renderBeforeNationalTeam = (option: string) => {
  const { name, slug, code } = sliceLongNameWithoutType(option);

  const team = code
    ? ({
        __typename: 'NationalTeam',
        slug,
        name,
        avatarUrl: null,
        country: { __typename: 'Country', slug: code, name },
      } as const)
    : ({
        __typename: 'Club',
        slug,
        name,
        avatarUrl: getClubAvatarUrl(slug),
      } as const);

  return <TeamAvatar size={24} team={team} />;
};

export const RefineClub = (limit?: number) =>
  buildRefineI18nList({
    filter: FILTERS.team,
    renderBefore,
    limit,
  });
export const RefineActiveClub = (limit?: number) =>
  buildRefineI18nList({
    filter: FILTERS.activeClub,
    renderBefore,
    limit,
  });

export const RefineBackendActiveClub = (limit?: number) => {
  return {
    key: 'club',
    type: 'list',
    attribute: 'club',
    Component: ({ visible }) => (
      <RefineBackendI18nList
        visible={visible}
        attribute="club"
        renderBefore={renderBefore}
        limit={limit}
      />
    ),
    title: <GqlFilterTitle name="club" title={FILTERS.activeClub.title} />,
    accordionOptions: { startsOpen: false },
  } satisfies FilterWidget;
};

export const RefineBackendClub = (limit?: number) => {
  return {
    key: 'team',
    type: 'list',
    attribute: 'team',
    Component: ({ visible }) => (
      <RefineBackendI18nList
        visible={visible}
        attribute="team"
        renderBefore={renderBefore}
        limit={limit}
      />
    ),
    title: <GqlFilterTitle name="team" title={FILTERS.team.title} />,
    accordionOptions: { startsOpen: false },
  } satisfies FilterWidget;
};

export const RefineBackendTeam = (limit?: number) => {
  return {
    key: 'team',
    type: 'list',
    attribute: 'team',
    Component: ({ visible }) => (
      <RefineBackendI18nList
        visible={visible}
        attribute="team"
        renderBefore={renderBeforeNationalTeam}
        limit={limit}
      />
    ),
    title: <GqlFilterTitle name="team" title={FILTERS.team.title} />,
    accordionOptions: { startsOpen: true },
  } satisfies FilterWidget;
};
